import { FormGroup } from "@angular/forms";
import { ObligatoriedadDocumentosService } from "src/app/core/services/obligatoriedadDocumento/obligatoriedadDocumento.service";
import { DateTimeService } from "src/app/core/utils/datetime.service";

export abstract class DocumentosParentesco {
    protected datosAdicionales: any;
    protected datosPersona: any;

    constructor(
        protected personaControl: FormGroup,
        datosAdicionales: any,
        protected documentosService: ObligatoriedadDocumentosService
    ) {
        this.datosAdicionales = datosAdicionales;
        this.datosPersona = personaControl.getRawValue();
    }

    abstract obtenerDocumentos(): Promise<void>;

    protected calcularEdad(fechaNacimiento: Date): number {
        return DateTimeService.calcularEdad(new Date(fechaNacimiento));
    }
}
